import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
body{
  font-family: 'SF Pro Text', sans-serif, 'Roboto','Helvetica Neue';
  background-color: rgb(242,245,247);
  color: #242c33;
  font-size: 1.625rem;
}
`;

export default GlobalStyles;